export const RIBEIRAO_PRETO_WHATS_APP = '551636391545'
export const DEFAULT_WHATSAPP = '552220410353'
export const WHATSAPP_LINK = 'https://api.whatsapp.com/send?phone='
export const DEFAULT_CONTACT_NUMBER = '10353'

export const CONTACT_OPTIONS = {
  SMS: 'SMS',
  EMAIL: 'EMAIL',
}

export const CONTACT_OPTIONS_LABEL = {
  [CONTACT_OPTIONS.SMS]: 'SMS',
  [CONTACT_OPTIONS.EMAIL]: 'E-mail',
}

export const TOKEN_CONFIRMATION_ERROR_MESSAGE = 'Código inválido'
